import { use, useEffect, useState } from "react";
import { IRegionalProps } from "../../CustomAssetTree";
import { Checkbox } from "@rio-cloud/rio-uikit";

interface IAssetHeader {
  assetData?: IRegionalProps[]
  selectAll: () => void
  unselectAll: () => void
}

const AssetHeader = ({assetData, selectAll, unselectAll}: IAssetHeader) => {
  const [isHover, setIsHover] = useState(false);
  const [indeterminateCheckbox, setIndeterminateCheckbox] = useState(false);

  useEffect(() => {
    if(!indeterminateCheckbox) {
      unselectAll()
      return
    }

    selectAll()

  }, [indeterminateCheckbox])

  const totalRegional = assetData?.length;

  const totalClient =  assetData?.reduce(
    (sum, regional) => sum + regional.clients.length,
    0
  );

  const totalContracts = assetData?.reduce(
    (sum, regional) =>
      sum +
      regional.clients.reduce(
        (clientSum, client) => clientSum + client.contracts.length,
        0
      ),
    0
  );

  const totalVehicles = assetData?.reduce(
    (sum, regional) =>
      sum +
      regional.clients.reduce(
        (clientSum, client) =>
          clientSum +
          client.contracts.reduce(
            (contractSum, contract) =>
              contractSum + contract.vehicles.length,
            0
          ),
        0
      ),
    0
  );

  return (
    <div className="display-flex align-items-start justify-content-between gap-5 padding-x-15 margin-left-1 padding-bottom-20 border border-bottom-only ">
      <div className="form-group margin-0">
          <div className="display-flex align-items-start">
            <Checkbox
              indeterminate={indeterminateCheckbox}
              onChange={() => setIndeterminateCheckbox(!indeterminateCheckbox)}
            >
            </Checkbox>

            <div className="display-flex flex-wrap align-items-center gap-10 margin-left-10 padding-left-10 border border-left-only border-color-light">
              <div className="display-flex align-items-center gap-5 padding-top-2">
                <span className="rioglyph rioglyph-role-management text-size-16"></span>
                <div className="label label-default label-condensed">{totalRegional}</div>
              </div>

              <div className="display-flex align-items-center gap-5 padding-top-2">
                <span className="rioglyph rioglyph-transfer text-size-16"></span>
                <div className="label label-default label-condensed">{totalClient}</div>
              </div>

              <div className="display-flex align-items-center gap-5 padding-top-2">
                <span className="rioglyph rioglyph-file-signature text-size-16"></span>
                <div className="label label-default label-condensed">{totalContracts}</div>
              </div>

              <div className="display-flex align-items-center gap-5 padding-top-2">
                <span className="rioglyph rioglyph-truck text-size-16"></span>
                <div className="label label-default label-condensed">{totalVehicles}</div>
              </div>
            </div>
          </div>
      </div>
      <div className="position-relative display-flex">
        {isHover ? (
          <div className="display-flex align-items-center position-absolute z-index-3" style={{top: -25, left: 10}}>
            <span className="rioglyph rioglyph-triangle-left text-size-h3 text-color-highlight-dark margin-right--10"></span>
            <div className="bg-highlight-dark padding-x-20 padding-y-10">
              <p className="margin-0 text-bold margin-bottom-5">Legenda:</p>
              <div className="display-flex align-items-center gap-15">
                <div className="display-flex align-items-center gap-5">
                  <span className="rioglyph rioglyph-role-management"></span>
                  <p className="margin-0">Regional</p>
                </div>
                <div className="display-flex align-items-center gap-5">
                  <span className="rioglyph rioglyph-transfer"></span>
                  <p className="margin-0">Cliente</p>
                </div>
                <div className="display-flex align-items-center gap-5">
                  <span className="rioglyph rioglyph-file-signature"></span>
                  <p className="margin-0">Contrato</p>
                </div>
                <div className="display-flex align-items-center gap-5">
                  <span className="rioglyph rioglyph-truck"></span>
                  <p className="margin-0">Veículo</p>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        <span
          className="rioglyph rioglyph-info-sign text-color-primary text-size-18 z-index-max"
          onMouseEnter={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
        >
        </span>
      </div>
    </div>
  )
}

export default AssetHeader
